module.exports = __webpack_public_path__ + "img/linuxStep3.e74c206d.png";